import { ReactRef, mergeRefs } from 'app/utils/mergeRef';
import { useMemo } from 'react';

export function useMergeRefs<T>(...refs: (ReactRef<T> | null | undefined)[]) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => mergeRefs(...refs), refs);
}
